import { render, staticRenderFns } from "./CasesKa.vue?vue&type=template&id=56436e1d&scoped=true&"
import script from "./CasesKa.vue?vue&type=script&lang=js&"
export * from "./CasesKa.vue?vue&type=script&lang=js&"
import style0 from "./CasesKa.vue?vue&type=style&index=0&id=56436e1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56436e1d",
  null
  
)

export default component.exports